module.exports = __webpack_public_path__ + "static/img/SIENA-MAPLE.5463e13.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/SIENA-MAPLE.png
// module id = nPFg
// module chunks = 0